<mat-toolbar color="primary">
    <span>Labos</span>
    <button (click)="newLabo()" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>note_add</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>    
</mat-toolbar>
<app-labo-table [location]="'panel'"></app-labo-table>